<template>
  <div>
    <title-list-navbar
      :items="'carGroupListView'"
      :title="enumHelper.MyPages.VAGON_GRUBU_YONETIMI"
      :active-tab="activeTab"
      :data-toggle="'modal'"
      :data-target="'#carGroupsDefinitionModal'"
      @all="allCarGroups()"
      @draft="filterCarGroups('DRAFT')"
      @waitingApproval="filterCarGroups('WAITING_APPROVAL')"
      @deleted="filterCarGroups('DELETED')"
      @addButton="addNewCarGroups()"
    />
    <base-alert />
    <section ref="bTablePageWidth" class="stationInformationArea statusListPage mt-3">
      <div class="container-fluid">
        <div class="row">
          <div v-if="filteredCarGroups !== undefined" class="col-lg-9">
            <div class="row" :style="{ minHeight: filteredCarGroups.length <= 0 ? '100%' : null }">
              <div class="col-12 contentPadding">
                <div class="stationArea objectArea" :style="{ minHeight: filteredCarGroups.length <= 0 ? '100%' : null }">
                  <div class="row justify-content-between">
                    <loading :active.sync="loading" :is-full-page="false" />
                    <transition name="dataTable-fade-in">
                      <foo-table
                        :filtered-items="filteredCarGroups"
                        :filtered-fields="filteredFieldsCarGroups"
                        :total-rows="totalRows"
                        :b-table-width="bTableWidth"
                        :current-page.sync="currentPage"
                        :per-page.sync="perPage"
                        :filter-included-fields="filterIncludedFields"
                        :page-name="'CAR_GROUP'"
                        :table-columns-data="tableColumnsData"
                        :row-details="rowDetails"
                        @selectedEntityRowClicked="selectCarGroup"
                        @resetRadioButtonAndPermissions="resetRadioButtonAndPermissions"
                        @onFiltered="onFiltered"
                        @selectedEntityHistory="loadSelectedCarGroupHistory"
                      >
                        <template #baseSelect>
                          <multi-select-wrapper
                            v-model="baseSelectModel"
                            :options="filteredResourceGroups"
                            :placeholder="'Vagon Grubu Adı'"
                            :text-field="'name'"
                            :value-field="'tempId'"
                            :searchable="true"
                            :internal-search="true"
                            @input="filterBaseSelect($event)"
                          />
                        </template>
                      </foo-table>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card statusArea">
              <div class="card-body">
                <work-flow-control-box
                  :publish-permission="publishPermission"
                  :update-permission="updatePermission"
                  :reject-permission="rejectPermission"
                  :recall-permission="recallPermission"
                  :cancel-permission="cancelPermission"
                  :submit-for-approval-permission="submitForApprovalPermission"
                  :delete-permission="deletePermission"
                  :loading-btn-state="loadingBtnState"
                  :data-target-create-update="'#carGroupsDefinitionModal'"
                  :spinner="loadingCarGroup"
                  @publish="publish()"
                  @reject="reject()"
                  @recall="recall()"
                  @cancel="cancel()"
                  @submitForApproval="submitForApproval()"
                  @createNewEntity="addNewCarGroups()"
                  @updateEvent="updateSelectedCarGroup()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--modal start-->
    <!-- physical properties Delete Modal -->
    <base-modal-component
      v-if="selectedCarGroup"
      :id="'deleteModal'"
      :btn-text="'Evet'"
      :image="'icon-modal-question.svg'"
      :header-text="'Vagon Grubu'"
      :inner-text="selectedCarGroup.name"
      :entity-title="'Bu Vagon Grubu kaydını'"
      :modal-text="'silmek istediğinize emin misiniz ?'"
      :spinner="loadingBtnState === 'deleteCarGroups' ? true : false"
      @deleteEntity="deleteCarGroups()"
    />
    <!-- physical properties Warning Modal -->
    <base-modal-component :id="'warningModal'" :image="'icon-modal-warning.svg'" :modal-type="'warning'" />
    <!-- physical properties history Modal -->
    <div id="historyModal" class="modal fade staffModal" tabindex="-1" aria-labelledby="historyModal" aria-hidden="true">
      <div ref="bTablePageWidthHistory" class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title">Vagon Grubu Geçmişi</h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"><img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" /></span>
            </button>
          </div>
          <div class="modal-body scrollbar">
            <div class="container-fluid stationInformationArea">
              <div class="row justify-content-between stationArea objectArea p-0">
                <loading :active.sync="loadingHistory" :is-full-page="false" />
                <transition name="dataTable-fade-in">
                  <history-foo-table
                    v-show="!loadingHistory"
                    :filtered-items="carGroupsHistory"
                    :filtered-fields="shownHistoryFields"
                    :total-rows="totalRowsHistories"
                    :b-table-width-history="bTableWidthHistory"
                    :current-page.sync="currentPageHistory"
                    :per-page.sync="perPageHistory"
                    :filter-included-fields="filterIncludedFieldHistories"
                    :page-name="'CAR_GROUP'"
                    @onFiltered="onFilteredHistory"
                  >
                    <template #selectedEntityName>
                      <div class="dataTableP">
                        <p v-if="selectedCarGroup" class="filterP">{{ selectedCarGroup.name }}</p>
                      </div>
                    </template>
                  </history-foo-table>
                </transition>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Kapat</button>
          </div>
        </div>
      </div>
    </div>

    <!-- physical properties definition Modal -->
    <validation-observer ref="carGroupsObserver" slim>
      <form @submit.prevent="createCarGroups()">
        <div id="carGroupsDefinitionModal" class="modal fade staffModal" tabindex="-1" aria-labelledby="carGroupsDefinitionModal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-scrollable">
            <div class="modal-content">
              <div class="modal-header">
                <h3 v-if="selectedCarGroup.id === undefined" class="modal-title">Vagon Grubu Tanımlama</h3>
                <h3 v-else class="modal-title">Vagon Grubu Güncelleme</h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true"><img src="../../../public/src/images/icon-modal-close.svg" alt="icon-modal-close" /></span>
                </button>
              </div>

              <div class="modal-body scrollbar">
                <div class="container-fluid">
                  <div class="row justify-content-sm-center">
                    <div class="col-sm-8">
                      <div class="row">
                        <div class="col-md-12">
                          <base-input
                            :id="'carGroupName'"
                            v-model="selectedModelForModal.name"
                            :input-label-text="'Vagon Grubu Adı'"
                            :required-star="true"
                            :rules="{ required: true }"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer align-self-center px-sm-0">
                <loading :active.sync="createLoading" :is-full-page="false" class="btnLoading" />
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Vazgeç</button>
                <base-button :btn-text="'Kaydet'" :btn-type="'submit'" :spinner="createLoading ? true : false" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </validation-observer>
    <!--    excel modal-->
    <excel-modal ref="excelModal" :excel-fields="excelFields" :data="carGroups" :file-name="'Vagon_Grubu_Tablosu'" @emitDownloadExcel="downloadExcel()" />
  </div>
</template>

<script>
import BaseButton from "../../component/element/buttons/BaseButton.vue";
import BaseInput from "../../component/element/form/input/BaseInput";
import Vue from "vue";
import historyDataTableDestroy from "../../mixins/historyDataTableDestroy";
import ServiceResponseHelper from "../../mixins/serviceResponseHelper";
import BaseAlert from "../../component/element/BaseAlert";
import Loading from "vue-loading-overlay";
import commonEntityProperties from "../../mixins/commonEntityProperties";
import WorkFlowControlBox from "../../component/element/WorkFlowControlBox";
import BaseModalComponent from "../../component/modals/BaseModalComponent";
import commonMethods from "../../mixins/commonMethods";
import enumHelper from "../../util/enumHelper";
import TitleListNavbar from "../../component/common/TitleListNavbar.vue";
import HistoryFooTable from "../../component/HistoryFooTable.vue";
import FooTable from "../../component/FooTable.vue";
import initDataTable from "../../mixins/initDataTable";
import ExcelModal from "../../component/ExcelModal.vue";
import moment from "moment";
import callBreadcrumb from "../../util/callBreadcrumb";
import MultiSelectWrapper from "../../component/element/form/select/MultiSelectWrapper.vue";

export default {
  name: "CarGroupListView",
  components: {
    MultiSelectWrapper,
    ExcelModal,
    FooTable,
    HistoryFooTable,
    TitleListNavbar,
    BaseAlert,
    BaseButton,
    BaseInput,
    Loading,
    WorkFlowControlBox,
    BaseModalComponent,
  },
  mixins: [
    historyDataTableDestroy,
    ServiceResponseHelper,
    commonEntityProperties,
    commonMethods,
    initDataTable({
      stateName: "carGroups",
      fields: [
        { key: "name", label: "Vagon Grubu  Adı", sortable: true },
        { key: "lastUpdateDate", label: "Son Değiştirilme Tarihi", sortable: true },
        { key: "username", label: "Kullanıcı", sortable: true },
        { key: "status", label: "Durum", sortable: true },
        { key: "history", label: "Geçmiş" },
      ],
      fieldsHistories: [
        { key: "name", label: "Vagon Grubu Adı", sortable: true },
        { key: "lastUpdateDate", label: "Son Değiştirilme Tarihi", sortable: true },
        { key: "username", label: "Kullanıcı", sortable: true },
        { key: "status", label: "Durum", sortable: true },
      ],
      filterIncludedFields: ["name", "lastUpdateDate", "user", "status", "history"],
      filterIncludedFieldHistories: ["name", "updateDateView", "username", "statusView"],
      itemList: "carGroups",
      filteredItemList: "filteredCarGroups",
      rowDetails: [
        { name: "lastUpdateDate", width: 1200, isAStatus: false, isAHistory: false, title: "Son Değiştirilme Tarihi" },
        { name: "username", width: 1200, isAStatus: false, isAHistory: false, title: "Kullanıcı" },
        { name: "status", width: 768, isAStatus: true, isAHistory: false },
        { name: "history", width: 576, isAStatus: false, isAHistory: true },
      ],
    }),
  ],
  data() {
    return {
      tableColumnsData: [
        { name: "name", isARadioCheckInput: true, isAStatus: false, isAHistory: false },
        { name: "lastUpdateDate", isARadioCheckInput: false, isAStatus: false, isAHistory: false },
        { name: "username", isARadioCheckInput: false, isAStatus: false, isAHistory: false },
        { name: "status", isARadioCheckInput: false, isAStatus: true, isAHistory: false },
        { name: "history", isARadioCheckInput: false, isAStatus: false, isAHistory: true },
      ],
      shownHistoryFields: [
        { key: "name", label: "Vagon Grubu Adı", sortable: true },
        { key: "lastUpdateDate", label: "Son Değiştirilme Tarihi", sortable: true },
        { key: "username", label: "Kullanıcı", sortable: true },
        { key: "status", label: "Durum", sortable: true },
      ],
      carGroupsHistory: [],
      carGroups: [],
      carGroup: { name: null },
      activeTab: "ALL",
      loading: false,
      loadingHistory: false,
      createLoading: false,
      loadingBtnState: "",
      loadingCarGroup: false,
      selectedDataTableIndex: null,
      excelFields: [
        { id: 1, text: "Vagon Grubu Adı", value: "name" },
        {
          id: 2,
          text: "Yayın Durumu",
          value: "intentId",
          isHasCallBack: true,
          callback: (intentId) => {
            if (intentId !== 0) {
              let entity = this.carGroups.find((x) => x.intentId === intentId);
              return entity.intents[0].type + " | " + entity.intents[0].status;
            } else {
              return "PUBLISHED";
            }
          },
        },
        {
          id: 3,
          text: "Son Değiştirilme Tarihi",
          value: "lastUpdateDate",
          isHasCallBack: true,
          callback: (date) => {
            return moment(date).add(3, "hour").format("DD.MM.YYYY HH:mm");
          },
        },
        {
          id: 4,
          text: "Kullanıcı",
          value: "username",
          isHasCallBack: true,
          callback: (user) => {
            if (user) {
              return user;
            } else {
              return "Kullanıcı Bilgisi Bulunamamıştır.";
            }
          },
        },
      ],
      selectedModelForModal: {},
      breadcrumbItems: callBreadcrumb.carGroupListView,
    };
  },
  computed: {
    selectedCarGroup: {
      get() {
        return this.$store.getters.getSelectedCarGroup;
      },
      set(value) {
        this.$store.commit("setSelectedCarGroup", value);
      },
    },
  },
  created() {
    this.fetchCarGroups();
  },

  methods: {
    downloadExcel() {
      this.$refs.excelModal.$refs.downloadExcel.$el.click();
    },
    fetchCarGroups() {
      this.loading = true;
      this.$store
        .dispatch("loadCarGroups")
        .then((response) => {
          this.loading = false;
          response.forEach((entity) => {
            entity.tempId = this.idGenerator();
          });
          Vue.set(this, "carGroups", response);
          Vue.set(this, "filteredCarGroups", response);
          this.$nextTick(() => {
            this.filterCarGroups(this.activeTab);
            this.clickFirstEntityOfList();
          });
        })
        .finally(() => {
          this.loading = false;
          this.selectedCarGroup = {};
          this.resetRadioButtonAndPermissions();
          this.setBaseSelectDefaultValue();
        });
    },
    selectCarGroup(carGroup) {
      Vue.set(this, "selectedCarGroup", carGroup);
      Vue.set(this, "selectedModelForModal", JSON.parse(JSON.stringify(carGroup)));

      if (this.selectedCarGroup === null) return; //TODO Burası incelenecek.
      this.defineEntityProperties(this.selectedCarGroup);
    },
    updateSelectedCarGroup() {
      // ! TODO: backend tarafından istek gelince düzeltilecek
      if (this.selectedCarGroup.id !== 0) {
        this.loadingCarGroup = true;
        this.$store.dispatch("loadCarGroup", { id: this.selectedCarGroup.id }).then((response) => {
          this.loadingCarGroup = false;
          this.selectedCarGroup = response;
        });
      }
    },
    translateStatusToTurkish(status) {
      switch (status) {
        case "DRAFT":
          return "Taslak";
        case "WAITING_APPROVAL":
          return "Onay Bekliyor";
        case "OVERRIDDEN":
          return "Değiştirilmiş";
        case "PUBLISHED":
          return "Yayında";
        case "UNPUBLISHED":
          return "Yayınlanmamış";
        case "CANCELLED":
          return "İptal";
        default:
          return status;
      }
    },

    loadSelectedCarGroupHistory(carGroup) {
      this.selectedCarGroup = carGroup;
      this.loadingHistory = true;

      this.$store
        .dispatch("loadSelectedCarGroupHistory", carGroup)
        .then((response) => {
          this.loadingHistory = false;
          response.forEach((history) => {
            history.model = JSON.parse(history.model);
            history.name = history.model.name;
            history.updateDateView = moment(history.updateDate).add(3, "hour").format("DD.MM.YYYY HH:mm");
            history.statusView = this.translateStatusToTurkish(history.status);
          });
          this.carGroupsHistory = response;
          this.totalRowsHistories = this.carGroupsHistory.length;
          $("#historyModal").modal("show");
        })
        .finally(() => {
          this.loadingHistory = false;
        });
    },

    addNewCarGroups() {
      $("#carGroupsDefinitionModal").on("shown.bs.modal", function () {
        document.getElementById("input-carGroupName").focus();
      });
      Vue.set(this, "selectedModelForModal", {});
      this.$store.commit("setSelectedCarGroup", {});
      this.carGroup = { name: null };
      this.resetRadioButtonAndPermissions();
      this.$refs.carGroupsObserver.reset();
    },

    createCarGroups() {
      this.$refs.carGroupsObserver.validate().then((success) => {
        if (!success) {
          this.callAlert(4, "Lütfen zorunlu alanları doldurunuz.", "danger", "Uyarı");
        } else {
          this.selectedCarGroup.name = this.selectedModelForModal.name;
          if (this.selectedCarGroup.intents !== undefined && this.selectedCarGroup.intents !== null) {
            if (this.selectedCarGroup.intents[0].type !== enumHelper.CAR_GROUP.CREATE || this.selectedCarGroup.intents[0].status !== "DRAFT") {
              this.selectedCarGroup.intentId = 0;
            }
          }
          delete this.selectedCarGroup.intents;
          this.createLoading = true;
          this.$store
            .dispatch("createCarGroup", this.selectedCarGroup)
            .then((response) => {
              this.createLoading = false;
              if (response.status === 200) {
                this.fetchCarGroups();
                this.currentPage = 1;
                this.callAlert(
                  4,
                  this.getAlertTextForCRUD(
                    enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""),
                    this.selectedCarGroup.name,
                    this.selectedCarGroup.id === undefined ? "create" : "update"
                  ),
                  "success",
                  "Başarılı"
                );
              } else {
                this.errorResponse(response);
              }
              this.$refs.carGroupsObserver.reset();
              $("#carGroupsDefinitionModal").modal("hide");
            })
            .finally(() => {
              this.carGroup = { name: null };
              this.selectedCarGroup = { name: null };
              this.createLoading = false;
              this.$refs.carGroupsObserver.reset();
              $("#carGroupsDefinitionModal").modal("hide");
            });
        }
      });
    },

    submitForApproval() {
      if (this.submitForApprovalPermission === false) return;

      this.loadingBtnState = "submitForApproval";
      this.$store
        .dispatch("sendToApprovalCarGroup", this.selectedCarGroup)
        .then(() => {
          this.defineEntityProperties(this.selectedCarGroup);
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "send_for_approval"),
            "success",
            "Başarılı"
          );
          this.fetchCarGroups();
        })
        .finally(() => {
          this.loadingBtnState = null;
          this.resetRadioButtonAndPermissions();
          this.setBaseSelectDefaultValue();
        });
    },
    resetRadioButton() {
      if (document.querySelector(".stationTable tr input:checked")) {
        document.querySelector(".stationTable tr input:checked").checked = false;
      }
    },

    publish() {
      if (this.publishPermission === false) {
        return;
      }
      this.loadingBtnState = "publish";
      this.$store
        .dispatch("publishCarGroup", this.selectedCarGroup)
        .then((entity) => {
          if (entity.status === 500) {
            this.callAlert(4, "İşlem gerçekleştirilememektedir.", "danger", "İşlem Hatası");
            return;
          }
          let status = entity.intents ? entity.intents[0].type : entity === "" ? "DELETE" : "";
          if (entity) {
            this.selectedCarGroup = entity;
            this.callAlert(
              4,
              this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "publish", status),
              "success",
              "Başarılı"
            );
          } else {
            this.callAlert(
              4,
              this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "publish", status),
              "success",
              "Başarılı"
            );
            this.selectedCarGroup = {};
          }
          this.fetchCarGroups();
        })
        .finally(() => {
          this.loadingBtnState = null;
          this.resetRadioButtonAndPermissions();
        });
    },

    reject() {
      if (this.rejectPermission === false) return;

      this.loadingBtnState = "reject";
      this.$store
        .dispatch("rejectCarGroup", this.selectedCarGroup)
        .then(() => {
          let status = this.defineEntityProperties(this.selectedCarGroup);
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "reject", status),
            "success",
            "Başarılı"
          );
        })
        .finally(() => {
          this.loadingBtnState = null;
          this.fetchCarGroups();
          this.resetRadioButtonAndPermissions();
          this.setBaseSelectDefaultValue();
        });
    },

    recall() {
      if (this.recallPermission === false) return;
      this.loadingBtnState = "recall";
      this.$store
        .dispatch("recallCarGroup", this.selectedCarGroup)
        .then(() => {
          //TODO:istek hatalı
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "recall"),
            "success",
            "Başarılı"
          );
        })
        .finally(() => {
          this.defineEntityProperties(this.selectedCarGroup);
          this.loadingBtnState = null;
          this.fetchCarGroups();
          this.resetRadioButtonAndPermissions();
          this.setBaseSelectDefaultValue();
        });
    },

    cancel() {
      if (this.cancelPermission === false) return;
      this.loadingBtnState = "cancel";
      this.$store
        .dispatch("cancelCarGroup", this.selectedCarGroup)
        .then(() => {
          //TODO:istek hatalı
          this.callAlert(
            4,
            this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "cancel"),
            "success",
            "Başarılı"
          );
        })
        .finally(() => {
          this.defineEntityProperties(this.selectedCarGroup);
          this.loadingBtnState = null;
          this.fetchCarGroups();
          this.resetRadioButtonAndPermissions();
          this.setBaseSelectDefaultValue();
        });
    },

    deleteCarGroups() {
      if (this.selectedCarGroup.intentId && this.selectedCarGroup.intentId > 0 && !this.selectedCarGroup.id) {
        if (this.deleteDraftPermission === false) {
          return;
        }
        this.loadingBtnState = "deleteCarGroups";
        this.$store
          .dispatch("deleteDraftCarGroup", this.selectedCarGroup)
          .then((response) => {
            if (response === "warning") {
              $("#warningModal").modal();
            } else if (response.status === 200 && response.data === "") {
              this.callAlert(
                4,
                this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "deleteIntent"),
                "success",
                "Başarılı"
              );
              this.selectedCarGroup = {};
              this.fetchCarGroups();
            }
          })
          .finally(() => {
            this.loadingBtnState = null;
          });
      } else {
        if (this.deletePermission === false) {
          return;
        }
        this.loadingBtnState = "deleteCarGroups";
        this.$store
          .dispatch("deleteCarGroup", this.selectedCarGroup)
          .then((response) => {
            if (response === "warning") {
              $("#warningModal").modal();
              return;
            }
            this.selectedCarGroup = response;
            this.defineEntityProperties(this.selectedCarGroup);
            this.callAlert(
              4,
              this.getAlertTextForCRUD(enumHelper.MyPages.VAGON_GRUBU_YONETIMI.replace(" Yönetimi", ""), this.selectedCarGroup.name, "delete"),
              "success",
              "Başarılı"
            );
            this.fetchCarGroups();
          })
          .finally(() => {
            this.loadingBtnState = null;
          });
      }
    },
    filterCarGroups(status) {
      // this.manageActiveTab(status);
      this.activeTab = status;
      this.loading = true;
      //TODO:Temporary Code Below, it's not cool everytime send request due to filtering.
      if (status === "DRAFT") {
        this.filteredCarGroups = this.carGroups.filter((carGroup) => {
          return carGroup.intents && carGroup.intents[0].status === "DRAFT";
        });
      } else if (status === "ALL") {
        this.allCarGroups();
      } else if (status === "WAITING_APPROVAL") {
        this.filteredCarGroups = this.carGroups.filter((carGroup) => {
          return (
            (carGroup.intents && carGroup.intents[0].status === "WAITING_APPROVAL") ||
            (carGroup.intents && carGroup.intents[0].status === "PUBLISHED") ||
            (carGroup.intents && carGroup.status === "DECLINED")
          );
        });
      } else {
        this.filteredCarGroups = this.carGroups.filter((carGroup) => {
          return carGroup.intents && carGroup.intents[0].status === status;
        });
      }
      this.$nextTick(() => {
        this.totalRows = this.filteredCarGroups.length;
      });
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    allCarGroups() {
      this.activeTab = "ALL";
      this.loading = true;
      this.filteredCarGroups = [...this.carGroups];
      this.totalRows = this.filteredCarGroups.length;
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
  },
  //---- methods end ----- //
};
</script>

<style scoped></style>
